import { createSnippet, getSnippet, getSnippets, updateSnippet } from './snippets.api'
import { queryOptions, skipToken, useMutation } from '@tanstack/react-query'
import { StudioSnippet, StudioSnippetFilterData } from '@/features/snippets'

export const snippetsQueries = {
  all: () => ['snippets'],
  lists: () => [...snippetsQueries.all(), 'list'],
  list: (filter: StudioSnippetFilterData = {}) =>
    queryOptions({
      queryKey: [...snippetsQueries.lists(), filter],
      queryFn: () => getSnippets(filter),
    }),

  details: () => [...snippetsQueries.all(), 'detail'],
  detail: (id?: number) =>
    queryOptions({
      queryKey: [...snippetsQueries.all(), 'detail', id],
      queryFn: id ? () => getSnippet(id) : skipToken,
    }),
}

export const useCreateSnippet = () =>
  useMutation({
    mutationFn: (snippet: StudioSnippet) => createSnippet(snippet),
  })

export const useUpdateSnippet = (id: number) =>
  useMutation({
    mutationFn: (snippet: StudioSnippet) => updateSnippet({ ...snippet, id }),
  })
